import Utils from './utils';
import SpritePoly from './spritePoly';

/**
 * 
 */
export default class SpritePolyRipples extends SpritePoly {

	/**
	 * single PIXI graphics object to render multiple expanding circle particles,
	 * handles its own lists internally and positions itself at 0,0
	 * so that individual particles can be spawned at regualar game coords.
	 * all particles are rendered in the same color
	 * @param {Object} args
	 * @param {String} args.layer name of layer within current scene to be added to, defaults to 'default'
	 * @param {Number} args.max fixed particle limit, if breached new particles will overwrite old ones default 1000
	 */
	constructor(args) {
		super(args);
		this.initPaths = false;
		this.circles = [];
		this.segments = 9;
		this.maxAngle = Math.PI*2; // + 0.1; // avoid float inaccuracy, ensure circle paths are fully closed
		this.step = this.maxAngle / this.segments;
		this.damping = 0.03;
		let max = args.max || 1000;
		while(max > 0) {
			this.circles.push([0,0,0,0,0,0,false]); // pre-fill array with inactive particles
			max--;
		}
		this.pointer = 0;
	}

	init(entity) {
		super.init(entity);
		this.tracers = -1;
		this.alpha = 0.5;
		this.slop = 0.5;
		this.setMultiColorMode();
	}

	/**
	 * @param {*} x 
	 * @param {*} y
	 * @param {*} radius start radius
	 * @param {*} rv radius velocity (multiplier)
	 * @param {*} expire miliseconds
	 * @param {*} time negative values for pre-delay
	 * @param {*} color
	 */
	addRipple(x, y, radius, rv, expire=250, time=0, color=0x00bb55) {
		this.pointer %= this.circles.length;
		this.circles[this.pointer] = [x, y, radius, rv, expire, time, true, color];
		this.pointer++;
	}

	generateParticlePaths(delta, deltaNormal) {
		this.paths = [];
		let a;
		let s;
		let d = 1 - (deltaNormal * this.damping);
		// iterate through particles
		for(let i = 0; i < this.circles.length-1; i++) {
			let p = this.circles[i];
			if(!p[6]) continue; // inactive
			if(p[5] < 0) {
				p[5] += delta; // don't appear yet
			} else {
				if(p[5] > p[4]) {
					p[6] = false; // expire
				} else {
					// plot circle
					let path = [];
					a = Math.random();
					s = -1;
					while(s < this.segments) {
						path.push([p[0]+Math.sin(a)*p[2], p[1]+Math.cos(a)*p[2]]);
						a += this.step;
						s++;
					}
					p[2] += p[3] * deltaNormal; // radius += radius velocity
					p[3] *= d;
					p[5] += delta; // tick
					path[0][2] = p[7]; // store color after first vertex pair
					this.paths.push(path);
				}
			}
		}
	}

	update(delta, deltaNormal) {
		this.generateParticlePaths(delta, deltaNormal);
		super.update(delta, deltaNormal);
	}

}